// extracted by mini-css-extract-plugin
export default {"heading6":"heading-06_heading6__GFryR","semibold":"heading-06_semibold__mE-FM"};